<template>
  <div v-if="attributes?.length" class="space-y-2">
    <UAccordion
      :items="accordionItems"
      multiple
      :ui="{
        wrapper: 'divide-y divide-gray-100',
        item: {
          wrapper: 'group',
          trigger: {
            base: 'flex w-full items-center justify-between py-3 text-left text-sm',
            icon: 'hidden'
          },
          content: 'py-3 px-1'
        }
      }"
    >
      <template #default="{ item, open }">
        <div class="flex items-center justify-between w-full py-2">
          <span class="font-medium text-gray-700">{{ item.label }}</span>
          <div class="flex items-center gap-2">
            <span v-if="item.count" class="text-xs text-orange-500 font-medium">
              {{ item.count }}
            </span>
            <UIcon
              name="i-heroicons-chevron-down"
              class="w-4 h-4 text-gray-500 transform transition-transform duration-200"
              :class="[open && 'rotate-180']"
            />
          </div>
        </div>
      </template>

      <template #item="{ item }">
        <div class="space-y-2">
          <UCheckbox
            v-for="term in item.attribute.terms"
            :key="term.id"
            :label="`${term.name}`"
            :model-value="
              selectedAttributes?.[item.attribute.id]?.includes(term.id)
            "
            @update:model-value="$emit('toggle', item.attribute.id, term.id)"
            color="orange"
          />
        </div>
      </template>
    </UAccordion>
  </div>
</template>

<script setup>
const props = defineProps({
  attributes: {
    type: Array,
    required: true,
    default: () => []
  },
  selectedAttributes: {
    type: Object,
    default: () => ({})
  }
})

defineEmits(['toggle'])

// Seçili özellik sayısını hesapla
const getSelectedCount = (attribute) => {
  return props.selectedAttributes?.[attribute.id]?.length || 0
}

// Accordion öğelerini hazırla (varsayılan olarak açık)
const accordionItems = computed(() => {
  return props.attributes.map((attribute) => ({
    label: attribute.name,
    count: getSelectedCount(attribute),
    attribute,
    defaultOpen: true
  }))
})
</script>
